import { Instagram, MessageCircle, Phone } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, WHATSAPP_URL, WHATSAPP_NUMBER } from "../lib/api";
import { useSeo } from "../lib/hooks";
import { Reveal } from "../components/Reveal";

export default function Contact() {
  useSeo({ title: "Nous contacter", description: "Contactez NasDeal sur Instagram @NasDeal_ pour toute question sur nos parfums, vos commandes ou nos arrivages." });
  return (
    <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 sm:py-28" data-testid="contact-page">
      <Reveal>
        <p className="eyebrow mb-4">Une question ?</p>
        <h1 className="font-display text-5xl sm:text-6xl">Nous contacter</h1>
        <p className="mt-6 max-w-xl text-[#F8F6F1]/65 leading-relaxed">Pour toute question sur un parfum, une commande ou un arrivage, écrivez-nous directement sur Instagram. Nous vous répondons en message privé.</p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-14 relative overflow-hidden border border-[#C9A45C]/30 bg-[#101010] p-8 sm:p-14 flex flex-col sm:flex-row gap-10 sm:items-center">
          <div className="h-28 w-28 sm:h-36 sm:w-36 shrink-0 border border-[#C9A45C]/50 flex items-center justify-center" data-testid="contact-instagram-logo">
            <Instagram className="h-14 w-14 sm:h-16 sm:w-16 text-[#C9A45C]" strokeWidth={1.2} />
          </div>
          <div className="flex-1">
            <p className="eyebrow">Instagram officiel</p>
            <p className="font-display text-4xl sm:text-5xl mt-2" data-testid="contact-instagram-handle">{INSTAGRAM_HANDLE}</p>
            <p className="mt-3 text-sm text-[#F8F6F1]/55">Nouveautés, arrivages, promotions et service client.</p>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="btn-gold mt-8" data-testid="contact-instagram-link">
              <MessageCircle className="h-4 w-4" /> Nous contacter sur Instagram
            </a>
          </div>
        </div>
      </Reveal>
      <Reveal delay={0.2}>
        <div className="mt-6 border border-[#C9A45C]/20 p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-3 justify-between" data-testid="contact-whatsapp-block">
          <div><p className="eyebrow">Par WhatsApp</p><p className="font-display text-2xl mt-1" data-testid="contact-whatsapp-number">{WHATSAPP_NUMBER}</p></div>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="btn-outline-gold !py-3" data-testid="contact-whatsapp-link"><Phone className="h-4 w-4" /> Écrire sur WhatsApp</a>
        </div>
      </Reveal>
      <Reveal delay={0.25}>
        <div className="mt-6 border border-[#C9A45C]/20 p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-3 justify-between" data-testid="contact-email-block">
          <div><p className="eyebrow">Par e-mail</p><p className="font-display text-2xl mt-1">Nasdeal55@gmail.com</p></div>
          <a href="mailto:Nasdeal55@gmail.com" className="btn-outline-gold !py-3" data-testid="contact-email-link">Écrire un e-mail</a>
        </div>
      </Reveal>
    </div>
  );
}
